"use client";

function ConfigWapper({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>;
}

export default ConfigWapper;
